import {ActionList} from '@primer/react'
import {ListUnorderedIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {useSidebarActivityOpenTimeline} from './use-sidebar-activity-open-timeline'
import styles from '../ActivityRows.module.css'
import sidebarListStyles from '../../SidebarActionList.module.css'

export function FullTimelineAction() {
  const openTimeline = useSidebarActivityOpenTimeline()

  return (
    <ActionList
      variant="full"
      aria-label="Additional activity actions"
      className={clsx(sidebarListStyles.flush, sidebarListStyles.compact, styles.viewAllList)}
    >
      <ActionList.Item className={styles.labelRow} onSelect={event => openTimeline(event.currentTarget)}>
        <ActionList.LeadingVisual>
          <ListUnorderedIcon />
        </ActionList.LeadingVisual>
        View all activity
      </ActionList.Item>
    </ActionList>
  )
}
